export const inventoryControl = {
	label: "Inventario",
};
